export const GET_USER_PRODUCT = '/api/v1/user/service/'
